import o from "./colorSchemes.js";
import i from "./cssVariables.js";
import r from "./MuiAccordion.js";
import m from "./MuiAccordionActions.js";
import f from "./MuiAccordionDetails.js";
import t from "./MuiAccordionSummary.js";
import c from "./MuiAlert.js";
import n from "./MuiAlertTitle.js";
import p from "./MuiAutocomplete.js";
import g from "./MuiBreadcrumbs.js";
import u from "./MuiButton.js";
import e from "./MuiButtonBase.js";
import $ from "./MuiCheckbox.js";
import M from "./MuiChip.js";
import a from "./MuiCssBaseline.js";
import l from "./MuiDialog.js";
import s from "./MuiDialogActions.js";
import d from "./MuiDialogTitle.js";
import A from "./MuiFab.js";
import h from "./MuiPaginationItem.js";
import S from "./MuiRadio.js";
import b from "./MuiRating.js";
import D from "./MuiSelect.js";
import B from "./MuiSlider.js";
import C from "./MuiSnackbarContent.js";
import k from "./MuiSpeedDial.js";
import y from "./MuiSpeedDialIcon.js";
import T from "./MuiTooltip.js";
import x from "./shape.js";
import I from "./typography.js";
const co = {
  colorSchemes: o,
  cssVariables: i,
  typography: I,
  shape: x,
  components: {
    MuiAccordion: r,
    MuiAccordionActions: m,
    MuiAccordionDetails: f,
    MuiAccordionSummary: t,
    MuiAlert: c,
    MuiAlertTitle: n,
    MuiAutocomplete: p,
    MuiBreadcrumbs: g,
    MuiButton: u,
    MuiButtonBase: e,
    MuiCheckbox: $,
    MuiChip: M,
    MuiCssBaseline: a,
    MuiDialog: l,
    MuiDialogActions: s,
    MuiDialogTitle: d,
    MuiFab: A,
    MuiPaginationItem: h,
    MuiRadio: S,
    MuiRating: b,
    MuiSelect: D,
    MuiSlider: B,
    MuiSnackbarContent: C,
    MuiSpeedDial: k,
    MuiSpeedDialIcon: y,
    MuiTooltip: T
  }
};
export {
  co as default
};
